import React from 'react';

const FilterIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="17" viewBox="0 0 19 17" className={className}>
    <g id="filter_1_" data-name="filter (1)" transform="translate(-3.25 -4.25)">
      <path id="Path_22646" data-name="Path 22646" d="M6.236,4.25A3.016,3.016,0,1,0,9.221,7.266,3,3,0,0,0,6.236,4.25ZM4.879,7.266A1.357,1.357,0,1,1,6.236,8.637,1.364,1.364,0,0,1,4.879,7.266Z" transform="translate(0 0)" fill="currentColor" fillRule="evenodd" />
      <path id="Path_22647" data-name="Path 22647" d="M12.064,6.25a.823.823,0,0,0,0,1.645H20.75a.823.823,0,0,0,0-1.645Z" transform="translate(0.686 0.194)" fill="currentColor" />
      <path id="Path_22648" data-name="Path 22648" d="M18.236,14.25a3.016,3.016,0,1,0,2.986,3.016A3,3,0,0,0,18.236,14.25Zm-1.357,3.016a1.357,1.357,0,1,1,1.357,1.371A1.364,1.364,0,0,1,16.879,17.266Z" transform="translate(1.029 0.968)" fill="currentColor" fillRule="evenodd" />
      <path id="Path_22649" data-name="Path 22649" d="M4.064,16.25a.823.823,0,0,0,0,1.645H12.75a.823.823,0,0,0,0-1.645Z" transform="translate(0 1.161)" fill="currentColor" />
    </g>
  </svg>
);

export default FilterIcon;
